import { Switch } from 'antd';
import { useState } from 'react';
import useRetainedTableState from '../hooks/useRetainedTableFilterState';

const ShowPreOrderSwitch = ({
  finalWhereFiltersRef,
  finalWhereFilters,
  setFinalWhereFilters,
  fetchOrders,
  setIsOrderLoading,
  tableFilterKey = null,
  setPaginationProp,
  paginationPropRef,
  setOrderList,
  paginationProp,
  margin,
  setSortedInfo,
  sortedInfoRef,
  sortedInfo,
}) => {
  const [previousSort, setPreviousSort] = useState({});
  const sortField = {
    column: {
      title: 'ORDER ID',
      dataIndex: 'createdAt',
      key: 'createdAt',
      align: 'left',
      ellipsis: true,
      className: 'max-width-column',
      sorter: true,
      width: 150,
    },
    columnKey: 'createdAt',
    field: 'createdAt',
    order: 'ascend',
  };
  const { saveRetainedFilterState } = useRetainedTableState();
  const handleFilterChange = (value) => {
    setIsOrderLoading(true);
    setFinalWhereFilters({ ...finalWhereFilters, isPreOrder: value });

    if (finalWhereFiltersRef)
      // eslint-disable-next-line no-param-reassign
      finalWhereFiltersRef.current = {
        ...finalWhereFiltersRef?.current,
        isPreOrder: value,
      };

    setPaginationProp({ ...paginationProp, current: 1, skip: 0 });
    if (paginationPropRef) {
      // eslint-disable-next-line no-param-reassign
      paginationPropRef.current = {
        ...paginationPropRef?.current,
        current: 1,
        skip: 0,
      };
    }
    if (value) {
      setPreviousSort(sortedInfoRef?.current);
      setSortedInfo(sortField);
      if (sortedInfoRef) {
        // eslint-disable-next-line no-param-reassign
        sortedInfoRef.current = sortField;
      }
    } else {
      setSortedInfo(previousSort);
      if (sortedInfoRef) {
        // eslint-disable-next-line no-param-reassign
        sortedInfoRef.current = previousSort;
      }
    }

    if (tableFilterKey)
      saveRetainedFilterState([tableFilterKey], {
        filters: { ...finalWhereFilters, isPreOrder: value },
        sort: sortedInfoRef.current,
        paginationProp: { ...paginationProp, current: 1, skip: 0 },
      });

    setOrderList([]);
    fetchOrders();
  };

  return (
    <div
      className={`d-flex gap-4 align-center  justify-end ${
        margin ? 'mb-16' : ''
      }`}
    >
      <div>Only Pre-Orders</div>{' '}
      <Switch
        className="m-0 ml-8 mr-8"
        size="small"
        onChange={(value) => handleFilterChange(value)}
        checked={finalWhereFilters?.isPreOrder}
      />
    </div>
  );
};

export default ShowPreOrderSwitch;
